<template>
  <div id="login">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-layout allign-center justify-center wrap>
          <v-flex class="mt-8" xs12 sm8 md4 lg4>
            <v-card class="elevation-4 pa-3 mt-10">
              <v-card-text>
                <div class="layout column align-center">
                  <img src="@/assets/glyd.png" width="200" height="200" />

                  <!-- <h1 class="flex my-2">
                  “Dear Customer, kindly enter your email below to start the
                  process of registering your organization.”
                </h1> -->
                  <caption
                    style="
                      font-style: italic;
                      font-size: 15px;
                      font-family: Times New Roman;
                    "
                    v-if="step == 1"
                    class="mt-n8 layout font-weight-regular primary--text column align-center"
                  >
                    Dear Customer, kindly enter your email below to start the
                    process of registering your organization.
                  </caption>
                </div>

                <v-window v-model="step" touchless>
                  <v-window-item :value="1">
                    <v-card-text>
                      <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation
                        @submit.prevent
                      >
                        <v-text-field
                          outlined
                          dense
                          append-icon="mdi-person"
                          :rules="[
                            (v) => !!v || 'E-mail is required',
                            (v) => /.+@.+/.test(v) || 'E-mail must be valid',
                          ]"
                          label="E-mail"
                          value
                          v-model="username"
                        ></v-text-field>

                        <!-- <span class="caption grey--text text--darken-1"
                          >This is the Username you use to login to your
                          account</span
                      >-->
                      </v-form>
                    </v-card-text>
                  </v-window-item>

                  <v-window-item :value="2">
                    <v-card-text>
                      <v-form
                        ref="pwdForm"
                        v-model="validpwd"
                        lazy-validation
                        @submit.prevent
                      >
                        <v-text-field
                          :append-icon="show1 ? 'visibility' : 'visibility_off'"
                          :type="show1 ? 'text' : 'password'"
                          label="Enter New Password"
                          @click:append="show1 = !show1"
                          outlined
                          dense
                          v-model="Password"
                          :rules="newPasswordRules"
                          required
                        ></v-text-field>
                        <v-text-field
                          :append-icon="show2 ? 'visibility' : 'visibility_off'"
                          label="Re-Enter New Password"
                          :type="show2 ? 'text' : 'password'"
                          @click:append="show2 = !show2"
                          :rules="confirmPasswordRules"
                          outlined
                          dense
                          required
                          v-model="confirmPassword"
                        ></v-text-field>
                        <v-row justify="center"></v-row>
                      </v-form>
                    </v-card-text>
                  </v-window-item>

                  <v-window-item :value="3">
                    <v-card-text>
                      <v-form
                        ref="codeForm"
                        v-model="valid1"
                        lazy-validation
                        @submit.prevent
                      >
                        <v-text-field
                          append-icon="mdi-key"
                          label="Code "
                          type="string"
                          outlined
                          color="primary"
                          background-color="white"
                          dense
                          v-model="code"
                          :rules="codeValidationRules"
                        ></v-text-field>
                        <v-row justify="center">
                          <span>
                            <h1 class="primary--text">
                              The code has been sent to the email address you provided.
                            </h1>
                          </span>
                        </v-row>
                        <!-- <v-row>
                        <v-spacer />
                        <a>
                          <u>
                            <h1 class="primary--text mr-3">Resend code?</h1>
                          </u>
                        </a>
                      </v-row> -->
                      </v-form>
                    </v-card-text>
                  </v-window-item>
                </v-window>

                <!-- <v-divider></v-divider> -->
                <v-row v-if="step == 1" class="ml-4 mb-3">
                  <!-- <a @click="backToSignin" v-if="step == 1">
                  <u @click="backToSignin">
                    <h1>Back to Login</h1>
                  </u>
                </a> -->
                  <div @click.stop="">
                    Already Registered?
                    <a href="#" @click="backToSignin" class="text--bg">Login</a>
                  </div>
                </v-row>

                <v-row class="mx-4">
                  <v-btn
                    block
                    v-if="step == 1"
                    :v-show="false"
                    class="primary--text btn"
                    :loading="loadingLogin"
                    @click.prevent="createUser"
                    >Signup</v-btn
                  >
                </v-row>
                <v-row class="ml-5 mb-3 mt-6">
                  <a class="text--bg" @click="onBackClick" v-if="step == 2">
                    <u>Back</u>
                  </a>
                </v-row>
                <v-row class="mx-4">
                  <v-btn
                    v-if="step == 2"
                    :v-show="false"
                    @click.prevent="createUserpwd"
                    block
                    :loading="loadingLogin1"
                    class="primary--text btn"
                    >Next</v-btn
                  >
                </v-row>

                <v-row class="mx-4">
                  <v-btn
                    v-if="step == 3"
                    :v-show="false"
                    block
                    class="primary--text btn"
                    :loading="loadingLogin"
                    @click="confirmUser"
                    >Confirm</v-btn
                  >
                </v-row>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-dialog
      v-model="ConfirmDialog"
      height="500"
      width="600"
      persistent
      overlay-color="primary"
      overlay-opacity="0.9"
    >
      <v-card class="overflow-hidden" color="white" rounded="xl">
        <v-card-text
          style="
            font-style: normal;
            font-size: 18px;
            font-family: Times New Roman;
            margin-top: 30px;
          "
          class="font-weight-light black--text"
        >
          Dear Customer , thank you for successfully registering. Please check
          your email for login details.
        </v-card-text>

        <v-card-actions>
          <v-row class="mt-n6">
            <v-col cols="12" md="4">
              <v-img
                src="@/assets/glyd1.svg"
                width="120px"
                max-height="80px"
              ></v-img
            ></v-col>
            <v-col cols="12" md="5"></v-col>
            <v-col cols="12" md="2" class="mt-6">
              <v-btn color="primary " text @click="navigatortoLogin">
                Continue
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import { Auth } from "aws-amplify";
import { apiCall } from "@/Views/APICALL/APIcall.js";

// import { validateUser } from "@/graphql/graphqlapi.js";
export default {
  data() {
    return {
      ConfirmDialog: false,
      Password: "",
      loadingLogin: false,
      loadingLogin1: false,
      mode: "top",
      username: "",
      validpwd: "",
      show1: false,
      show2: false,
      valid: true,
      valid1: true,
      valid2: true,
      step: 1,
      loading: false,
      newPasswordRules: [
        (v) => !!v || "Password is required",
        (v) => v.length >= 8 || "Password cannot be less than 8 characters",
      ],
      confirmPasswordRules: [
        (v) =>
          (v && this.Password === this.confirmPassword) ||
          "Password not matching",
      ],
      code: "",
      codeValidationRules: [(v) => !!v || "Code is required"],
      snackbar: false,
      snackbarMsg: "Invalid Email and Password",
      email: "",
      password: "",
      confirmPassword: "",
      newPassword: "",
      show: false,
      state: 0,
      rules1: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 8 || "Min 8 characters",

        email: [
          (v) => !!v || "E-mail is required",
          (v) => /.+@.+/.test(v) || "E-mail must be valid",
        ],
        password: [
          (v) => !!v || "Password is required",
          (v) => v.length >= 8 || "Password must contain at least 8 characters",
        ],
        newPassword: [
          (v) => !!v || "Password is required",
          (v) => v.length >= 8 || "Min 8 characters",
        ],
        confirmPassword: [
          (v) => !!v || "Password is required",
          (v) =>
            (v && this.confirmPassword == this.newPassword) ||
            "Password not matching",
        ],
      },
    };
  },

  methods: {
    async createUser() {
      this.Password = "";
      this.confirmPassword = "";

      if (this.username != "" && this.$refs.form.validate()) {
        this.loadingLogin = true;
        var inputData = {
          method_name: "CAUTH",
          page_no: 0,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "CKUSEXTSIGNUP",
            email_id: this.username.trim(),
          },
        };
        var responseData = await apiCall(inputData);
        // console.log("CKUSEXTS", responseData);
        if (responseData.data.status == "USREXTS") {
          this.loadingLogin = false;
          this.username = "";
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "red",
          });
          this.$refs.form.resetValidation();
        } else if (responseData.data.status == "UNKNW") {
          this.loadingLogin = false;
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "red",
          });
          this.$refs.form.resetValidation();
        } else if (responseData.data.status == "NTEXST") {
          this.loadingLogin = false;
          this.step++;
        } else if (responseData.data.status == "00") {
          this.loadingLogin = false;
          this.step++;
        }
      }
    },

    async createUserpwd() {
      if (this.$refs.pwdForm.validate()) {
        // alert(20)
        if (this.Password == this.confirmPassword) {
          this.loadingLogin1 = true;

          // Auth.signUp({
          //   username: this.username,
          //   password: this.Password,
          //   // confirmPassword:this.confirmPassword,
          //   attributes: {
          //     email: this.username, // optional
          //   },
          // })
          //   .then((data) => {
          //     console.log(data);
          //     this.step++;
          //   })
          //   .catch((err) => {
          //     this.errormessage(err.message);
          //   });

          var inputData = {
            method_name: "CAUTH",
            page_no: 0,
            record_count: 0,
            page_size: 25,
            app_code: "CPORTAL",
            method_param: {
              action: "SIGNUP",
              email_id: this.username.trim(),
              password: this.Password,
            },
          };
          var responseData = await apiCall(inputData);
          //  console.log("LOGIN", responseData);
          if (responseData.data.status == "00") {
            this.loadingLogin1 = false;
            this.step++;
          } else {
            this.loadingLogin1 = false;
            this.$store.commit("snackbar/showMessage", {
              content: responseData.data.status_msg,
              color: "red",
            });
          }
        } else {
          this.Password = "";
          this.confirmPassword = "";
          this.loadingLogin1 = false;
          this.$store.commit("snackbar/showMessage", {
            content: " Password Not Matching",
            color: "red",
          });
        }
      }
    },
    async confirmUser() {
      this.loadingLogin = true;
      var inputData = {
        method_name: "CAUTH",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CNFVRFC",
          email_id: this.username,
          vcode: this.code,
        },
      };
      var responseData = await apiCall(inputData);

      if (responseData.data.status == "00") {
        // this.$router.push("/");
        this.ConfirmDialog = true;
        this.$store.commit("snackbar/showMessage", {
          content: "Signup Successful! Login to proceed.",
          color: "green",
        });
      } else if (responseData.data.status == "FAILED") {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "red",
        });
      }
      this.loadingLogin = false;
    },
    errormessage(message = "Something has gone wrong, please try again. ") {
      this.$store.commit("snackbar/showMessage", {
        content: message,
        color: "red",
      });
    },
    navigatortoLogin() {
      this.ConfirmDialog = false;
      this.$router.push("/");
    },
    // createUser() {
    //   this.step++;
    // },
    // createUserpwd() {
    //   this.step++;
    // },
    signup() {
      this.$router.push("signup");
    },
    onboard() {
      this.$router.push("OnBoard");
    },
    Login() {
      this.$router.push("/");
    },
    onBackClick() {
      // this.username = "";
      this.$refs.form.resetValidation();
      this.$refs.pwdForm.resetValidation();

      this.step--;
    },
    backToSignin() {
      this.$router.push("/");
    },
  },
};
</script>

<style scoped lang="css">
.bg {
  background: #1b3249 !important;
}
.btn {
  background: linear-gradient(
    90deg,
    rgba(165, 126, 60, 1) 0%,
    rgba(223, 192, 126, 1) 50%,
    rgba(165, 126, 60, 1) 100%
  );
}
.loginsmalltext {
  font-size: small;
}
.navbar {
  background: linear-gradient(
    to bottom,
    #2e4152 0%,
    #3c4d5d 50%,
    #202c37 100%
  ) !important;
}
#login {
  height: 100%;
  width: 100%;
  /* position: fixed; */
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background-image: url("~@/assets/GlydBackground.png");
  background-position: center center;
  /* -webkit-filter: blur(4px);
  filter: blur(4px); */
  /* background-color: black; */
  /* background-color: white; */
  background-repeat: no-repeat;
  background-size: 100%;
  touch-action: none;
}
h1 {
  font-size: small;
  color: blue;
}
#element {
  touch-action: none;
}
</style>
